<template>
    <div class="main container">
        <hint :chanImg="chanPic" :delImg="delPic"></hint>
        <left></left>
        <div class="tes abs grn1 opc non">
            <div class="btn-draw-tes cp ct">·画笔</div>
            <input class="range-rotate-tes cp" type="range" min="-180" max="180" value="0">
        </div>
        <div class="before abs non7">
            <div class="click-area abs ct cp" @click="FirstLoad()">
                <img src="img/gen/pic_tianjiatupian.png" class="default-pic">
                <br>
                <p>拖拽/点击添加图片</p>
                <div class="btn-first-load ma br19">添加图片</div>
                <div class="hint non">
                    <img src="img/gen/ico_tishi.png">
                    非VIP用户可转换最大2M的文件，升级VIP用户无大小限制。
                </div>
            </div>
            <img class="r-b abs" src="img/gen/bg_zhuans.png" alt>
        </div>
        <div class="right abs non">
            <div class="tool-container">
                <li
                    class="btn-text-new fl cp ct"
                    @click="StaText()"
                    @mouseenter="HoldTool('text',true)"
                    @mouseleave="HoldTool('text',false)"
                >
                    <img :src="ImgTool('text')">
                    <p>文字</p>
                </li>
                <li
                    class="btn-shape-new fl cp ct"
                    @click="StaShape()"
                    @mouseenter="HoldTool('shape',true)"
                    @mouseleave="HoldTool('shape',false)"
                >
                    <img :src="ImgTool('shape')">
                    <p>区域形状</p>
                </li>
                <li
                    class="btn-crop-into fl cp ct"
                    @click="StaCrop()"
                    @mouseenter="HoldTool('crop',true)"
                    @mouseleave="HoldTool('crop',false)"
                >
                    <img :src="ImgTool('crop')">
                    <p>裁剪</p>
                </li>
                <div class="dash fl"></div>
                <li
                    class="btn-rotate-menu fl cp ct"
                    @click="StaRoate()"
                    @mouseenter="HoldTool('rotate',true)"
                    @mouseleave="HoldTool('rotate',false)"
                >
                    <img :src="ImgTool('rotate')">
                    <p>旋转</p>
                </li>
                <li
                    class="btn-flip-x fl cp ct"
                    @click="FlipX()"
                    @mouseenter="HoldTool('flipX',true)"
                    @mouseleave="HoldTool('flipX',false)"
                >
                    <img :src="ImgTool('flipX')">
                    <p>横向镜像</p>
                </li>
                <li
                    class="btn-flip-y fl cp ct"
                    @click="FlipY()"
                    @mouseenter="HoldTool('flipY',true)"
                    @mouseleave="HoldTool('flipY',false)"
                >
                    <img :src="ImgTool('flipY')">
                    <p>纵向镜像</p>
                </li>
                <div class="dash fl"></div>
                <li
                    class="btn-select-into fl cp ct"
                    @click="ModSel()"
                    @mouseenter="HoldTool('select',true)"
                    @mouseleave="HoldTool('select',false)"
                >
                    <img :src="ImgTool('select')">
                    <p>框选</p>
                </li>
                <li
                    class="btn-del-go fl cp ct"
                    @click="Delete()"
                    @mouseenter="HoldTool('del',true)"
                    @mouseleave="HoldTool('del',false)"
                >
                    <img :src="ImgTool('del')">
                    <p>删除</p>
                </li>
                <li
                    class="btn-reset-go fl cp ct"
                    @click="Reset()"
                    @mouseenter="HoldTool('reset',true)"
                    @mouseleave="HoldTool('reset',false)"
                >
                    <img :src="ImgTool('reset')">
                    <p>重做</p>
                </li>
                <li
                    class="btn-redo-go fl cp ct non"
                    @click="Redo()"
                    @mouseenter="HoldTool('redo',true)"
                    @mouseleave="HoldTool('redo',false)"
                >
                    <img :src="ImgTool('redo')">
                    <p>恢复</p>
                </li>
                <li
                    class="btn-undo-back fl cp ct non"
                    @click="Undo()"
                    @mouseenter="HoldTool('undo',true)"
                    @mouseleave="HoldTool('undo',false)"
                >
                    <img :src="ImgTool('undo')">
                    <p>撤销</p>
                </li>
            </div>
            <div class="body-container white2 bds bd1">
                <!-- 图片编辑器，必须存在 -->
                <div class="tui-image-editor red1"></div>
            </div>
            <div class="float-crop-menu abs" v-show="isCrop">
                <li class="first br3 fl cp ct" @click="ModSel()">取消</li>
                <li class="blue1 br3 fl cp ct" @click="ApplyCrop()">确定</li>
            </div>
            <div class="list-container white2 fix">
                <li class="btn-move-left white3 bds bd1 fl cp ct">
                    <img src="img/gen/ico_shangyizhang.png">
                </li>
                <li class="btn-more-load white3 bds bd1 fl cp ct">
                    <img src="img/gen/ico_tianjiatupian.png">
                    <p>添加图片</p>
                </li>
                <li class="btn-move-right white3 bds bd1 fl cp ct">
                    <img src="img/gen/ico_xiayizhang.png">
                </li>
                <!-- 多个图片列表 -->
                <swiper :options="swiperOption" class="thumb">
                    <swiper-slide v-for="(image,index) in imageList" :key="index">
                        <div class="table cp">
                            <div
                                class="fg bds bd1 ct"
                                :class="{bd3 : index === focusIndex}"
                                @click="chooseImage(index, true)"
                            >
                                <img :src="image.url">
                            </div>
                            <img
                                class="delImg cp abs"
                                :class="{non : index !== focusIndex}"
                                src="img/gen/ico_shanchu.png"
                                @click="readyDel();"
                            >
                        </div>
                    </swiper-slide>
                    <swiper-slide v-for="v in defaultImg" :key="v.id" ref="defaultList">
                        <div class="noImage bds bd1">
                            <img src="img/gen/ico_wuwenjian.png">
                            <div class="l-b"></div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <parm :savImg="savPic"></parm>
        </div>
    </div>
</template>
<script>
import Common from "../mixin/tui-common.js";
import Editor from "../mixin/tui-editor.js";
import Basic from "../mixin/tui-basic.js";
//以上是具体的画布交互逻辑，仅在此页面有用
import Hint from "../components/common/Hint";
import Left from "../components/common/Left";
import Parm from "../components/common/Parm";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "EditImg",
    components: {
        Hint, Left, Parm, swiper, swiperSlide
    },
    mixins: [Common, Editor, Basic],
    mounted() {
        this.InitEditor();
    },
    computed: {
        defaultImg() {
            if (this.imageList.length > 9) {
                return;
            }
            //解决重复key bug
            let noImageLength = 9 - this.imageList.length;
            let noImageArr = [];
            for (let i = 1; i <= noImageLength; i++) {
                noImageArr.push({ id: -i });
            }
            return noImageArr;
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 9,
                centeredSlides: false,
                spaceBetween: 5,
                navigation: {
                    nextEl: ".btn-move-right",
                    prevEl: ".btn-move-left"
                }
            },
            imageList: [], //待编辑图片列表
            focusIndex: 0 //当前选中的index
        };
    },
    methods: {
        HoldTool(type, isIn) {
            //如果是 3，不进行 hover
            if (this.StaTool[type] != 3) {
                this.StaTool[type] = isIn ? 2 : 1;
            }
        },
        ImgTool(type) {
            var idx = this.StaTool[type];
            return 'img/tools/btn_' + this.UrlTool[type] + '0' + idx + '.png';
        },
        chanPic() {
            //同意切换图片，先渲染画布，再移动蓝框
            var _this = this;
            var idx = window.picGo;
            var fileLoad = _this.fileLoad = window.editorUrls[idx];
            var imageEditor = window.imageEditor;
            imageEditor
                .loadImageFromFile(fileLoad)
                .then(function () {
                    imageEditor.clearUndoStack(); //清理堆栈，防止能撤销
                    _this.rePage();
                    _this.ReUI();
                    _this.ShowImgSize(fileLoad);
                    window.$('.filename').find('input').val(fileLoad.name);
                    window.picIndex = idx;
                    _this.focusIndex = idx;
                })
                .catch(function () { });
        },
        readyDel() {
            //提示是否真要删除
            window.picAction = 'delPic';
            window.tuiHint.show();
        },
        delPic() {
            //同意删除
            var _this = this;
            var imageEditor = window.imageEditor;
            var idx = _this.focusIndex;
            _this.imageList.splice(idx, 1);
            //如果没有剩余图片了，不用 focusIndex=0
            if (_this.imageList.length < 1) {
                imageEditor.clearUndoStack();
                window.editorUrls = [];
                window.$(".before").show();
                window.$(".right").hide();
                //简单处理
            } else {
                window.editorUrls.splice(idx, 1);
                //先简单，到最后
                var len = window.editorUrls.length - 1;
                var fileLoad = window.editorUrls[len];
                imageEditor
                    .loadImageFromFile(fileLoad)
                    .then(function () {
                        imageEditor.clearUndoStack(); //清理堆栈，防止能撤销
                        _this.rePage();
                        _this.ReUI();
                        _this.ShowImgSize(fileLoad);
                        window.$('.filename').find('input').val(fileLoad.name);
                        _this.focusIndex = len;
                        window.picIndex = len; //防止再点最后一张会跳框
                    })
                    .catch(function () { });
            }
        },
        savPic() {
            //用户保存完图片后，把底下缩略图，右边图片尺寸，刷新一下
            //因为原来图片没有改变，所以。。。先不搞吧 savPath
            //C:\Users\Administrator\Desktop\狐1114-1.png
        },
        //图片加载进来
        renderImages(blobUrl) {
            this.imageList.push({ url: blobUrl });
            this.chooseImage(this.imageList.length - 1);
        },
        chooseImage(index, chan) {
            //同张图片点了没反应
            if (chan && this.focusIndex != index) {
                window.picAction = 'chanPic';
                window.picGo = index;
                window.tuiHint.show();
            } else {
                this.focusIndex = index;
                //新来图片的话，已经提示过，所以只是切换蓝框位置
            }
        },
        appendSlide() {
            this.swiperSlides.push(this.swiperSlides.length + 1);
        },
        prependSlide() {
            this.swiperSlides.unshift(this.swiperSlides[0] - 1);
        },
        popSlide() {
            this.swiperSlides.pop();
        },
        shiftSlide() {
            this.swiperSlides.shift();
        }
    }
};
</script>

<style scoped>
.default-pic {
    height: 148px;
}
.tes {
    left: 130px;
    bottom: 100px;
    z-index: 1;
    line-height: 40px;
}
.tes div {
    border-bottom: 1px solid #333333;
}
/* 用户尚未加载图片 */
.before,
.right {
    left: 114px;
    right: 0px;
    top: 41px;
    bottom: 0px;
}
.before .ct {
    width: 400px;
    top: 70px;
    left: 0px;
    right: 0px;
    margin: auto;
}
.before p {
    margin-top: 5px;
    margin-bottom: 22px;
    font-size: 14px;
    color: #464851;
}
.click-area {
    padding-top: 50px;
    padding-bottom: 50px;
}
.btn-first-load {
    width: 163px;
    height: 37px;
    line-height: 37px;
    font-size: 14px;
    color: #0090ff;
    border: 1px solid #0090ff;
}
.btn-first-load:hover {
    color: white;
    background-color: #0090ff;
}
.btn-first-load:active {
    color: white;
    background-color: #006cff;
}
.before .hint {
    margin-top: 26px;
    font-size: 12px;
    color: #7090a8;
}
.hint img {
    vertical-align: middle;
}
/* 加载图片后 */
.body-container {
    margin: 5px;
}
.tool-container,
.list-container {
    height: 77px;
}
.tool-container {
    width: 1020px;
    margin-left: 1px;
    padding-left: 9px;
    border-bottom: 1px solid #e2e5ec;
}
.tool-container li {
    margin: 13px 8px 0px 8px;
}
.tool-container p {
    padding-top: 2px;
    font-size: 12px;
    color: #464851;
}
.dash {
    margin-top: 12px;
    margin-left: 8px;
    padding-right: 8px;
    height: 53px;
    border-left: 1px dashed #d7dee4;
}
/* 底下 */
.list-container {
    left: 115px;
    right: 200px;
    bottom: 1px;
    border-top: 1px solid #e2e5ec;
}
.list-container li {
    margin-right: 5px;
    margin-top: 7px;
}
.list-container p {
    font-size: 12px;
    color: #7a8c9c;
}
.btn-move-left,
.btn-move-right {
    padding-top: 22px;
    width: 23px;
    height: 40px;
}
.btn-move-left {
    margin-left: 5px;
}
.btn-more-load {
    width: 69px;
    height: 62px;
}
.btn-more-load img {
    margin-top: 8px;
    margin-bottom: 5px;
}
li.btn-move-right {
    float: right;
    margin-right: 13px;
}
.float-crop-menu {
    top: 90px;
    right: 218px;
    line-height: 20px;
    font-size: 12px;
    color: white;
}
.float-crop-menu li {
    width: 48px;
    height: 21px;
}
.float-crop-menu .first {
    margin-right: 4px;
    background: rgba(0, 0, 0, 0.4);
}
/* swiper */
.thumb {
    width: 680px;
    margin-left: 0px;
    margin-top: 8px;
}
.table {
    width: 70px;
    height: 63px;
    display: table;
}
.table .fg {
    display: table-cell;
    vertical-align: middle;
}
.fg img {
    max-width: 69px;
    max-height: 62px;
}
.delImg {
    right: 0px;
    z-index: 2;
}
.noImage {
    width: 69px;
    height: 61px;
}
.noImage img {
    margin-left: 18px;
    margin-top: 17px;
}
.l-b {
    width: 14px;
    height: 14px;
    margin-top: 1px;
    border-top: 1px solid #e2e5ec;
    border-right: 1px solid #e2e5ec;
}
.r-b {
    right: 0px;
    bottom: 0px;
}
</style>